import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'

@Component
export default class GnbSiteMap extends Vue {
    @Prop({ type: Array }) siteMapItems!: appbase.cache.TMenuItem[]
    @Prop({ type: String }) userLang!: string
    siteMapSearchText: string = ''

    fnExpandSubMenu(menuId: number){
        let divSubObj = document.getElementById("divSiteMapSub_" + menuId);
        if (divSubObj !== undefined && divSubObj !== null){
            if (divSubObj.style.display == "none"){
                divSubObj.style.display = "";
            }
            else{
                divSubObj.style.display = "none";
            }
        }
    }

    fnGetMenuName(menuItem: appbase.cache.TMenuItem){
        return (this.userLang && this.userLang == 'ko-KR' ? menuItem.menuName : menuItem.menuNameEn)
    }

    fnSearchSiteMap(){
        // 메뉴명 없이 검색 시 모든 Sitemap 데이터 표시
        this.siteMapSearchText = (<HTMLInputElement>document.getElementById('txtSearchSiteMap')).value; 
    }

    @Watch('siteMapSearchText')
    fnIsDisplay(menuItem: appbase.cache.TMenuItem, level:number)
    {   
        if (this.siteMapSearchText == ''){
            return "";
        }
        else{
            if (menuItem.menuName){
                if (this.fnCheckMenuName(menuItem, level)){
                    return '';
                }
            }
        }

        return "display:none"
    }

    fnCheckMenuName(menuItem: appbase.cache.TMenuItem, menuLevel: number){
        if (this.userLang.toLowerCase() == 'ko-kr' ? (menuItem.menuName.indexOf(this.siteMapSearchText) > -1)
                                               : (menuItem.menuNameEn.indexOf(this.siteMapSearchText) > -1))
        {
            return true;
        }
        else if (menuLevel < 3 && menuItem.hasChildren && menuItem.children.length > 0)
        {
            for(let i = 0; i < menuItem.children.length; i++){
                let isChecke = this.fnCheckMenuName(menuItem.children[i], menuLevel + 1);
                if (isChecke) return true
            }
        }

        return false
    }
}